import React from 'react';
import { ArrowRight } from 'lucide-react';
import Reveal from './Reveal';

export default function FinalCTA() {
  return (
    <section className="pb-20 lg:pb-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-ink text-parchment px-6 py-14 sm:px-12 sm:py-16">
            <div className="absolute -right-16 -top-20 w-72 h-72 rounded-full bg-copper-500/20 blur-3xl pointer-events-none" />
            <div className="absolute -left-10 bottom-0 w-56 h-56 rounded-full bg-pine-500/30 blur-3xl pointer-events-none" />
            <div className="relative max-w-2xl">
              <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-copper-100">
                Prêt à commencer
              </p>
              <h2 className="mt-4 font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-tight">
                Un esprit plus sain, un pas à la fois.
              </h2>
              <p className="mt-5 text-parchment/75 text-lg leading-relaxed">
                Des plans personnalisés, des activités stimulantes et un soutien
                communautaire pour aiguiser mémoire et équilibre émotionnel.
              </p>
              <a
                href="/s"
                className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-copper-500 text-paper font-bold hover:bg-copper-400 shadow-stamp transition-colors"
              >
                Commencer l’entraînement
                <ArrowRight size={18} strokeWidth={2.4} />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
